import type { IPublicClientApplication } from '@azure/msal-browser';

import { PublicClientApplication } from '@azure/msal-browser';

import { getGlobalConfig, configureGlobalClient } from './utils/configure-instance';

const globalClient: IPublicClientApplication = new PublicClientApplication(getGlobalConfig());

await globalClient.initialize();

configureGlobalClient(globalClient);

export default globalClient;
